// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.

const BlocksContainer =
  require("library/show/components/content/blocks/BlocksContainer").default

export const blocks = {
  icon: "shapes",
  title: "Build with Blocks",
  prompt: "Use the new blocks framework",
  form: BlocksContainer,
  confirm: {
    heading: "Switching to blocks will remove old content",
    body: "All content, responses, and stats will no longer be available for this step and any steps that use it.",
    confirmPrompt: "Switch to Blocks",
    cancelPrompt: "keep existing content"
  }
}
